// Verified facts about the AI visibility tools that AI assistants name next
// to monroya.ai. Every line comes from the vendor's own site and carries the
// date it was read there. Neutral wording only: no negative claims.
export type ToolFact = { name: string; site: string; pricing: string; note: string; checked: string };

export const TOOL_FACTS: ToolFact[] = [
  {
    name: "monroya.ai",
    site: "monroya.ai",
    pricing: "Free plan; $79, $199 or $299 per month",
    note: "ChatGPT, Claude, Gemini, Perplexity, Google AI Overviews and Google AI Mode on every paid plan",
    checked: "October 26, 2026",
  },
  {
    name: "Otterly.ai",
    site: "otterly.ai",
    pricing: "$29, $189 or $489 per month",
    note: "Prompt and link monitoring with a free trial",
    checked: "October 12, 2026",
  },
  {
    name: "Peec AI",
    site: "peec.ai",
    pricing: "From $95 per month ($80 billed annually)",
    note: "50 prompts across 3 engines you choose on the entry plan",
    checked: "October 12, 2026",
  },
  {
    name: "Scrunch AI",
    site: "scrunch.com",
    pricing: "From $250 per month (Core); Enterprise custom",
    note: "Core covers ChatGPT, Perplexity, Google AI Overviews and Copilot; 7-day free trial",
    checked: "October 18, 2026",
  },
  {
    name: "AthenaHQ",
    site: "athenahq.ai",
    pricing: "Free tier with $25 of credit, then $295 per month",
    note: "Credit-based usage",
    checked: "October 12, 2026",
  },
  {
    name: "Profound",
    site: "tryprofound.com",
    pricing: "Custom Enterprise pricing",
    note: "Answer and citation analytics for enterprise teams",
    checked: "October 20, 2026",
  },
];

export const TOOL_FACTS_NOTE =
  "Each tool's facts come from its own website on the date shown. Prices and plans change; check the vendor's site before you buy.";
